import { ItemsChecks } from '@playq/octopus2-economy';
import { ItemID } from '@playq/services-bookkeeper';
import { GenericFailure } from '@playq/services-shared';
import { PermModule } from '@playq/octopus2-auth';

import { useEitherQuery, IUseQueryOptionsExtended } from '/api/service-hooks';
import { useModulePermissions } from '/hooks/useModulePermissions';

import { appsInventoryCheckKeys, appsInventoryService } from './constants';

export const useAppsInventoryCheckItems = (
  items: ItemID[],
  options?: IUseQueryOptionsExtended<ItemsChecks | undefined, GenericFailure | Error>
) => {
  const { canRead } = useModulePermissions(PermModule.EconomyInventory);

  const { mutate, ...res } = useEitherQuery(
    appsInventoryCheckKeys.concat(items),
    () => appsInventoryService.checkItems(items),
    {
      ...options,
      enabled: options?.enabled !== false && canRead,
    }
  );

  return {
    ...res,
    mutate,
  };
};
